import * as React from "react";
import { forwardRef } from "react";
const TrashSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M10 4a1 1 0 0 0-1 1h6a1 1 0 0 0-1-1zm6.931 3H7.07l.804 12.067a1 1 0 0 0 .998.933h6.258a1 1 0 0 0 .998-.933zM7 5H4a1 1 0 0 0 0 2h1.064l.814 12.2A3 3 0 0 0 8.87 22h6.258a3 3 0 0 0 2.993-2.8L18.936 7H20a1 1 0 1 0 0-2h-3a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3", clipRule: "evenodd" }));
const ForwardRef = forwardRef(TrashSVG);
export default ForwardRef;
//# sourceMappingURL=Trash.js.map